<template>
  <FreeBottomSheet :name="name" class="gray-bg-bottom-sheet">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <h3 class="text-base font-medium">
          {{ t('passengerDataForm.document.title') }}
        </h3>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="px-4">
        <div
          class="bg-background-neutral-secondary divide-situational-lightgrey divide-y rounded-2xl px-4 pb-3 pt-2"
        >
          <button
            v-for="docType in passengerDocumentTypes"
            :key="docType"
            type="button"
            class="flex w-full items-center justify-between space-x-3 py-4 text-left font-medium"
            :class="{
              'text-text-positive-primary': selectedDocType === docType,
            }"
            @click="
              () => {
                emit('onDocumentTypeSelect', docType);
                hide();
              }
            "
          >
            <span class="truncate">
              {{ t(`passengerDataForm.document.type.${docType}`) }}
            </span>
            <img
              v-if="selectedDocType === docType"
              src="../../../assets/images/green-check-icon.svg"
              width="24"
              height="24"
              alt=""
            />
          </button>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { computed, watch } from 'vue';

  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
  } from '../../../shared/ui';
  import {
    rwPassengersData as passengersData,
    rwPassengersDataTypes as passengersDataTypes,
  } from '../../../entities/rw-passengers-data';

  const props = defineProps<{
    name: string;
    selectedDocType: passengersDataTypes.DocumentType;
    fareType: string;
  }>();

  const emit = defineEmits<{
    onDocumentTypeSelect: [passengersDataTypes.DocumentType];
  }>();

  const { t } = useI18n();

  const { documentTypes } = passengersData.config;
  const adultOnlyDocTypes: passengersDataTypes.DocumentType[] = [
    documentTypes.ID,
    documentTypes.RELEASE_CERT,
    documentTypes.MILITARY_ID,
    documentTypes.ID_LOSS_CERT,
  ];

  const documentChildTypes = Object.fromEntries(
    Object.entries(documentTypes).filter(
      ([, value]) => !adultOnlyDocTypes.includes(value),
    ),
  );
  const passengerDocumentTypes = computed(() =>
    props.fareType === passengersDataTypes.FareType.CHILD
      ? documentChildTypes
      : documentTypes,
  );

  watch(
    () => props.fareType,
    value => {
      if (
        value === passengersDataTypes.FareType.CHILD &&
        adultOnlyDocTypes.includes(props.selectedDocType)
      ) {
        emit('onDocumentTypeSelect', documentTypes.BIRTH_CERT);
      }
    },
    { immediate: true },
  );
</script>

<i18n src="../config/locales.json"></i18n>
